import { render, staticRenderFns } from "./BookCell.vue?vue&type=template&id=c53545c2&scoped=true&"
import script from "./BookCell.vue?vue&type=script&lang=js&"
export * from "./BookCell.vue?vue&type=script&lang=js&"
import style0 from "./BookCell.vue?vue&type=style&index=0&id=c53545c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53545c2",
  null
  
)

export default component.exports